import addCurrent from '../assets/images/add-current.svg';
import userIcon from '../assets/images/add-user.svg';
import add from '../assets/images/add.svg';
import addSeason from '../assets/images/add_season.svg';
import addUser from '../assets/images/add_user.svg';
import assignment from '../assets/images/assignment.svg';
import auditBegin from '../assets/images/audit_begin.svg';
import auditBeginIco from '../assets/images/audit_begin_ico.svg';
import _auth_setup from '../assets/images/auth_setup.svg';
import bulkUpload from '../assets/images/bulk_upload.svg';
import calender from '../assets/images/calendar_month.svg';
import checkFile from '../assets/images/check-file.svg';
import check from '../assets/images/check.svg';
import click_img from '../assets/images/click_img.svg';
import comingSoon from '../assets/images/coming-soon.svg';
import verifyEmail from '../assets/images/confirmation.svg';
import riceCrop from '../assets/images/crop.png';
import csvError from '../assets/images/csv-error.svg';
import csvIconGrey from '../assets/images/csv-icon-grey.svg';
import csvIcon from '../assets/images/csv-icon.svg';
import csvSuccess from '../assets/images/csv-success.svg';
import delete_ico from '../assets/images/delete.svg';
import download from '../assets/images/download.svg';
import downloadTemplate from '../assets/images/download_template.svg';
import document from '../assets/images/driving.png';
import editTemplate from '../assets/images/edit_template.svg';
import error from '../assets/images/error.svg';
import farmer from '../assets/images/farmer.png';
import farmer_report_active from '../assets/images/farmerReports/active_farmers.svg';
import farmer_report_approved from '../assets/images/farmerReports/approved_farmers.svg';
import farmer_loader_button from '../assets/images/farmerReports/farmer_loader_button.svg';
import farmers_info_icon from '../assets/images/farmerReports/farmers_info_icon.svg';
import farmer_report_under_review from '../assets/images/farmerReports/farmers_under_review.svg';
import farmer_report_without_club from '../assets/images/farmerReports/farmers_without_club.svg';
import farmer_report_rejected from '../assets/images/farmerReports/rejected_farmers.svg';
import farmer_report_terminated from '../assets/images/farmerReports/terminated_farmers.svg';
import farmer_report_clubs from '../assets/images/farmerReports/total_clubs.svg';
import fieldGuard from '../assets/images/field_guard.gif';
import google from '../assets/images/google.svg';
import info from '../assets/images/info.svg';
import live from '../assets/images/live.svg';
import lock from '../assets/images/locked.svg';
import maize from '../assets/images/maze.png';
import auditBeginNoFarmer from '../assets/images/no_farmer.svg';
import noResult from '../assets/images/no_result.svg';
import notAssigned from '../assets/images/not_assigned.svg';
import _organization_setup from '../assets/images/organization_setup.svg';
import outlook from '../assets/images/outlook.svg';
import pending from '../assets/images/pending.svg';
import persona from '../assets/images/person.svg';
import placeholder from '../assets/images/placeholder.svg';
import processing from '../assets/images/processing.svg';
import published from '../assets/images/published.svg';
import logo from '../assets/images/Raithu.svg';
import rings from '../assets/images/rings.svg';
import viewSeason from '../assets/images/season.svg';
import seasonSettings from '../assets/images/season_settings.svg';
import beans from '../assets/images/seasonReport/beans.svg';
import chickpea from '../assets/images/seasonReport/chickpea.svg';
import seasonReport_contract_overview from '../assets/images/seasonReport/contract_overview.svg';
import corn from '../assets/images/seasonReport/corn.svg';
import cotton from '../assets/images/seasonReport/cotton.svg';
import seasonReport_farmer_area_overview from '../assets/images/seasonReport/farmer_area_overview.svg';
import generic from '../assets/images/seasonReport/generic.svg';
import seasonReport_harvest_overview from '../assets/images/seasonReport/harvesto_overview.svg';
import seasonReport_input_debt_overview from '../assets/images/seasonReport/input_debt_overview.svg';
import rice from '../assets/images/seasonReport/rice.svg';
import seasonReport_season_goal from '../assets/images/seasonReport/season_goal.svg';
import seasonReport_sowing_overview from '../assets/images/seasonReport/sowing_overview.svg';
import soya from '../assets/images/seasonReport/soya.svg';
import sunflower from '../assets/images/seasonReport/sunflower.svg';
import wheat from '../assets/images/seasonReport/wheat.svg';
import sensorsOff from '../assets/images/sensors_off.svg';
import sessionExpiredHero from '../assets/images/session_expired_hero.png';
import submitTemplate from '../assets/images/submit_template.svg';
import success from '../assets/images/success.svg';
import target from '../assets/images/target.svg';
import unpublished from '../assets/images/unpublished-changes.svg';
import updateTemplate from '../assets/images/update_template.svg';
import uploadTemplate from '../assets/images/uploadTemplate.svg';
import user from '../assets/images/user.jpg';
import _user_management from '../assets/images/user_management.svg';
import userManagement_bulk_upload from '../assets/images/userManagement/bulk_upload.svg';
import userManagement_invite_user from '../assets/images/userManagement/invite_user.svg';
import users from '../assets/images/users.svg';
import welcome from '../assets/images/welcome.svg';
import wiltingSprout from '../assets/images/wilting_sprout.gif';
export interface AssetsType {
  images: {
    authSetup: string;
    organizationSetup: string;
    usermanagement: {
      bulkUpload: string;
      inviteUser: string;
    };
    farmerReports: {
      active: string;
      approved: string;
      underReview: string;
      withoutClub: string;
      rejected: string;
      terminated: string;
      clubs: string;
      info: string;
      loader: string;
    };
    seasonReport: {
      contractOverview: string;
      farmerAreaOverview: string;
      harvestOverview: string;
      inputDebtOverview: string;
      seasonGoal: string;
      sowingOverview: string;
      maize: string;
      target: string;
      users: string;
      cotton: string;
      soya: string;
      chickpea: string;
      beans: string;
      rice: string;
      wheat: string;
      corn: string;
      sunflower: string;
      generic: string;
    };
    agronomist: {
      rings: string;
    };
    userManagement: string;
    logo: string;
    verifyEmail: string;
    user: string;
    farmer?: string;
    document?: string;
    success?: string;
    calender?: string;
    add?: string;
    addCurrent?: string;
    delete_ico?: string;
    pending: string;
    info: string;
    addUser: string;
    bulkUpload: string;
    noResult: string;
    google: string;
    outlook: string;
    welcome: string;
    check: string;
    download: string;
    notAssigned: string;
    auditBegin: string;
    auditBeginNoFarmer: string;
    auditBeginIco: string;
    click_img: string;
    placeholder: string;
    comingSoon: string;
    addSeason: string;
    checkFile: string;
    assignment: string;
    seasonSettings: string;
    viewSeason: string;
    published: string;
    unpublished: string;
    live: string;
    riceCrop: string;
    userIcon: string;
    processing: string;
    csvIcon: string;
    csvError: string;
    csvSuccess: string;
    downloadTemplate: string;
    editTemplate: string;
    updateTemplate: string;
    submitTemplate: string;
    csvIconGrey: string;
    uploadTemplate: string;
    persona: string;
    error: string;
    sensorsOff: string;
    lock: string;
    fieldGuard: string;
    wiltingSprout: string;
    sessionExpiredHero: string;
  };
}

export const Assets: AssetsType = {
  images: {
    authSetup: _auth_setup,
    organizationSetup: _organization_setup,
    usermanagement: {
      bulkUpload: userManagement_bulk_upload,
      inviteUser: userManagement_invite_user,
    },
    farmerReports: {
      active: farmer_report_active,
      approved: farmer_report_approved,
      underReview: farmer_report_under_review,
      withoutClub: farmer_report_without_club,
      rejected: farmer_report_rejected,
      terminated: farmer_report_terminated,
      clubs: farmer_report_clubs,
      info: farmers_info_icon,
      loader: farmer_loader_button,
    },
    seasonReport: {
      contractOverview: seasonReport_contract_overview,
      farmerAreaOverview: seasonReport_farmer_area_overview,
      harvestOverview: seasonReport_harvest_overview,
      inputDebtOverview: seasonReport_input_debt_overview,
      seasonGoal: seasonReport_season_goal,
      sowingOverview: seasonReport_sowing_overview,
      maize: maize,
      target: target,
      users: users,
      cotton: cotton,
      soya: soya,
      chickpea: chickpea,
      beans: beans,
      rice: rice,
      wheat: wheat,
      corn: corn,
      sunflower: sunflower,
      generic: generic,
    },
    agronomist: {
      rings: rings,
    },
    userManagement: _user_management,
    logo: logo,
    verifyEmail: verifyEmail,
    user: user,
    farmer: farmer,
    document: document,
    success: success,
    calender: calender,
    add: add,
    addCurrent: addCurrent,
    delete_ico: delete_ico,
    pending: pending,
    info: info,
    addUser: addUser,
    bulkUpload: bulkUpload,
    noResult: noResult,
    google: google,
    outlook: outlook,
    welcome: welcome,
    check: check,
    download: download,
    notAssigned: notAssigned,
    auditBegin: auditBegin,
    auditBeginNoFarmer: auditBeginNoFarmer,
    auditBeginIco: auditBeginIco,
    click_img: click_img,
    placeholder: placeholder,
    comingSoon: comingSoon,
    addSeason: addSeason,
    checkFile: checkFile,
    assignment: assignment,
    seasonSettings: seasonSettings,
    viewSeason: viewSeason,
    published: published,
    unpublished: unpublished,
    live: live,
    riceCrop: riceCrop,
    userIcon: userIcon,
    processing: processing,
    csvIcon: csvIcon,
    csvError: csvError,
    csvSuccess: csvSuccess,
    downloadTemplate: downloadTemplate,
    editTemplate: editTemplate,
    updateTemplate: updateTemplate,
    submitTemplate: submitTemplate,
    csvIconGrey: csvIconGrey,
    uploadTemplate: uploadTemplate,
    persona: persona,
    error: error,
    sensorsOff: sensorsOff,
    lock: lock,
    fieldGuard: fieldGuard,
    wiltingSprout: wiltingSprout,
    sessionExpiredHero: sessionExpiredHero,
  },
};
